import { Link } from 'react-router';
import { EmptyState } from '../components/states';
import { usePageTitle } from '../layout/shellContext';

export function NotFoundPage() {
  usePageTitle('Страница не найдена');
  return (
    <section className="panel">
      <EmptyState
        title="Такого адреса нет"
        action={
          <Link className="btn-primary" to="/org">
            К оргструктуре
          </Link>
        }
      >
        Проверьте ссылку или выберите раздел в меню.
      </EmptyState>
    </section>
  );
}
